export const POINT_CAUSE = {
  EARN_FROM_ORDER: 'earn_from_order',
  PRODUCT_BONUS: 'product_bonus',
  REFERRAL: 'referral',
  SPEND_ON_ORDER: 'spend_on_order',
  EXPIRY: 'expiry',
  MANUAL_ADJUST: 'manual_adjust',
  GIFT: 'gift',
  ORDER_CANCEL: 'order_cancel',
  ORDER_REFUND: 'order_refund',
  SIGNUP_BONUS: 'signup_bonus',
  REDEEM_FOR_COUPON: 'redeem_for_coupon',
  // BE 系統 migration 對帳產生的 cause；後端已在前台過濾此欄位，僅作為後台顯示用，保留i18n字段作為前端防護。
  MIGRATION_RECONCILE: 'migration_reconcile',
} as const

export type PointCause = (typeof POINT_CAUSE)[keyof typeof POINT_CAUSE]

export const POINT_DIRECTION = {
  CREDIT: 'credit',
  DEBIT: 'debit',
} as const

export type PointDirection = (typeof POINT_DIRECTION)[keyof typeof POINT_DIRECTION]

export const POINT_CAUSE_LABEL: Record<PointCause, string> = {
  [POINT_CAUSE.EARN_FROM_ORDER]: '訂單獲得',
  [POINT_CAUSE.SPEND_ON_ORDER]: '訂單使用',
  [POINT_CAUSE.PRODUCT_BONUS]: '贈品點數',
  [POINT_CAUSE.REFERRAL]: '推薦碼獲得點數',
  [POINT_CAUSE.GIFT]: '站方贈送',
  [POINT_CAUSE.SIGNUP_BONUS]: '註冊獎勵',
  [POINT_CAUSE.MANUAL_ADJUST]: '手動調整',
  [POINT_CAUSE.EXPIRY]: '點數到期',
  [POINT_CAUSE.ORDER_CANCEL]: '取消訂單返還',
  [POINT_CAUSE.ORDER_REFUND]: '銷貨退回',
  [POINT_CAUSE.REDEEM_FOR_COUPON]: '點數兌換',
  [POINT_CAUSE.MIGRATION_RECONCILE]: '系統調整',
}
